import React, { useContext, useMemo } from "react";
import "./DetailsOverviewTable.css";
import { translations } from "../../../../utils/lang";
import { Context } from "../../../../context/Context";
import { APP_COLORS } from "../../../../utils/helpers";
import { integrationLabel, normalizeDeliveryAppKey } from "../../../../utils/integrations";

const APP_ORDER = ["jahez", "hungerstation", "toyou", "keeta", "ninja", "marsool"];
const appKeyOf = (value) => normalizeDeliveryAppKey(value) || value;

export default function DetailsOverviewTable({
  details = [],
  missing = [],
  objections = [],
}) {
  const { lang } = useContext(Context);
  // Count missing per app
  const missingCount = useMemo(() => {
    const count = {};
    APP_ORDER.forEach((app) => (count[app] = 0));
    missing.forEach((item) => {
      const app = appKeyOf(item.app);
      if (app && count[app] !== undefined) {
        count[app] += 1;
      }
    });
    return count;
  }, [missing]);

  // Count statuses per app
  const statusCount = useMemo(() => {
    const result = {};
    APP_ORDER.forEach((app) => {
      result[app] = { rejected: 0, canceled: 0, delivered: 0 };
    });

    details.forEach((item) => {
      const { orderStatus } = item;
      const app = appKeyOf(item.app);
      if (result[app] && orderStatus) {
        if (orderStatus === "Rejected") result[app].rejected += 1;
        else if (orderStatus === "Canceled" || orderStatus === "Cancelled")
          result[app].canceled += 1;
        else if (orderStatus === "Delivered") result[app].delivered += 1;
      }
    });

    return result;
  }, [details]);

  const result = objections.reduce((acc, item) => {
  const key = appKeyOf(item.app);
  const count = item.orderIds?.length || 0;

  acc[key] = (acc[key] || 0) + count;

  return acc;
}, {});

  return (
    <div className="details-overview-table">
      <div className="table-header">
        <div className="table-cell row-title"></div>
        {APP_ORDER.map((app) => (
          <div
            key={app}
            className="table-cell app-cell"
            style={{ background: APP_COLORS[app] }}
          >
            {integrationLabel(app, lang)}
          </div>
        ))}
      </div>

      {/* Rows */}
      <div className="table-row">
        <div className="table-cell row-title">
          {translations[lang].dailyAnalysis.title}
        </div>
        {APP_ORDER.map((app) => (
          <div key={app} className="table-cell">
            {missingCount[app]}
          </div>
        ))}
      </div>

      <div className="table-row">
        <div className="table-cell row-title">
          {translations[lang].dailyAnalysis.statuses.Rejected}
        </div>
        {APP_ORDER.map((app) => (
          <div key={app} className="table-cell">
            {statusCount[app].rejected}
          </div>
        ))}
      </div>

      <div className="table-row">
        <div className="table-cell row-title">
          {translations[lang].dailyAnalysis.statuses.Cancelled}
        </div>
        {APP_ORDER.map((app) => (
          <div key={app} className="table-cell">
            {statusCount[app].canceled}
          </div>
        ))}
      </div>

      <div className="table-row">
        <div className="table-cell row-title">
          {translations[lang].dailyAnalysis.statuses.Delivered}
        </div>
        {APP_ORDER.map((app) => (
          <div key={app} className="table-cell">
            {statusCount[app].delivered}
          </div>
        ))}
      </div>
      <div className="table-row">
        <div className="table-cell row-title">
          {translations[lang].dailyAnalysis.statuses.objected}
        </div>
        {APP_ORDER.map((app) => (
          <div key={app} className="table-cell">
            {result[app]}
          </div>
        ))}
      </div>
    </div>
  );
}
